<template>
  <div v-show="flag" class="advance-search-detail">
    <div class="input-container">
      <div class="group-input cols-span-2">
        <div class="name">คำค้นหา</div>
        <input v-model="keyword" name="keyword" type="text" class="input-keyword" :placeholder="keywordPlaceholder" />
      </div>
      <div class="group-input">
        <div class="name">วันที่ส่งหนังสือ</div>
        <div class="between">
          <Datepickers
            v-model="deliveryDate"
            name="deliveryDate"
            class-n="date-size"
            :max-date="deliveryDateTo"
            placeholder="กรุณาระบุ"
          />
          <div class="to">ถึง</div>
          <Datepickers
            v-model="deliveryDateTo"
            name="deliveryDateTo"
            class-n="date-size"
            :min-date="deliveryDate"
            placeholder="กรุณาระบุ"
          />
        </div>
      </div>
      <div v-if="!hidePickUpDate" class="group-input">
        <div class="name">วันที่รับหนังสือ</div>
        <div class="between">
          <Datepickers
            v-model="pickUpDate"
            name="pickUpDate"
            class-n="date-size"
            :max-date="pickUpDateTo"
            placeholder="กรุณาระบุ"
          />
          <div class="to">ถึง</div>
          <Datepickers
            v-model="pickUpDateTo"
            name="pickUpDateTo"
            class-n="date-size"
            :min-date="pickUpDate"
            placeholder="กรุณาระบุ"
          />
        </div>
      </div>
      <div v-if="showSender" class="group-input">
        <div class="name">ผู้ส่ง/เจ้าของเรื่อง</div>
        <Autocomplete
          v-model="from"
          name="from"
          placeholder="กรุณาระบุ"
          :option-select="optionSelect.from"
          @keyup-data="onKeyFrom"
        />
      </div>
      <div v-if="!hideSakLaw" class="group-input">
        <div class="name">ลำดับศักดิ์กฎหมาย</div>
        <Select
          v-model="sakLaw"
          name="sakLaw"
          class-n="select-size"
          placeholder="กรุณาระบุ"
          :option-select="optionSelect.sakLaw"
        />
      </div>
      <div v-if="!hideLegalType" class="group-input">
        <div class="name">ประเภทประกาศ</div>
        <Select v-model="legalType" name="legalType" placeholder="กรุณาระบุ" :option-select="optionSelect.legalType" />
      </div>

      <div class="group-input">
        <div class="display-flex">
          <div class="group-input">
            <div class="name">ชั้นความเร็ว</div>
            <Select v-model="urgent" name="urgent" placeholder="กรุณาระบุ" :option-select="optionSelect.urgent" />
          </div>
          <div class="group-input">
            <div class="name">ชั้นความลับ</div>
            <Select v-model="secret" name="secret" placeholder="กรุณาระบุ" :option-select="optionSelect.secret" />
          </div>
        </div>
      </div>
      <div v-if="showResponsible" class="group-input">
        <div class="name">ผู้รับผิดชอบหลัก</div>
        <Autocomplete
          v-model="responsible"
          name="responsible"
          placeholder="กรุณาระบุ"
          :option-select="optionSelect.responsibles"
          @keyup-data="onKeyResponsible"
        />
      </div>
    </div>
    <div class="group-button-advance">
      <button class="btn btn-gray" @click="$emit('clear')">
        <img src="@/assets/images/sync-duotone-2.svg" class="icon-clear" />
        ล้างข้อมูล
      </button>
      <button class="btn btn-secondary" @click="$emit('search-advance')">
        <img src="@/assets/images/search-plus-duotone.svg" class="icon-search" />
        ค้นหา
      </button>
    </div>
  </div>
</template>

<script>
import Datepickers from '../date/index.vue'
import Select from '../select/index.vue'
import Autocomplete from '../autocompleteSearch/index.vue'

export default {
  name: 'SharedAdvanceSearch',
  components: {
    Datepickers,
    Select,
    Autocomplete,
  },
  props: {
    flag: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Object,
      required: true,
    },
    showResponsible: {
      type: Boolean,
      default: true,
    },
    showSender: {
      type: Boolean,
      default: true,
    },
    keywordPlaceholder: {
      type: String,
      default: 'กรุณากรอก เลขหนังสือนำส่ง/เรื่อง ที่ต้องการค้นหา',
    },
    hideLegalType: {
      type: Boolean,
      default: false,
    },
    hideSakLaw: {
      type: Boolean,
      default: false,
    },
    hidePickUpDate: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'clear', 'search-advance', 'keyup-from'],
  computed: {
    optionSelect() {
      return (
        this.modelValue.optionSelect || {
          sakLaw: [],
          legalType: [],
          urgent: [],
          secret: [],
          from: [],
          responsibles: [],
        }
      )
    },
    keyword: {
      get() {
        return this.modelValue.keyword
      },
      set(value) {
        this.updateField('keyword', value)
      },
    },
    deliveryDate: {
      get() {
        return this.modelValue.deliveryDate
      },
      set(value) {
        this.updateField('deliveryDate', value)
      },
    },
    deliveryDateTo: {
      get() {
        return this.modelValue.deliveryDateTo
      },
      set(value) {
        this.updateField('deliveryDateTo', value)
      },
    },
    pickUpDate: {
      get() {
        return this.modelValue.pickUpDate
      },
      set(value) {
        this.updateField('pickUpDate', value)
      },
    },
    pickUpDateTo: {
      get() {
        return this.modelValue.pickUpDateTo
      },
      set(value) {
        this.updateField('pickUpDateTo', value)
      },
    },
    from: {
      get() {
        return this.modelValue.from
      },
      set(value) {
        this.updateField('from', value)
      },
    },
    sakLaw: {
      get() {
        return this.modelValue.sakLaw
      },
      set(value) {
        this.updateField('sakLaw', value)
      },
    },
    legalType: {
      get() {
        return this.modelValue.legalType
      },
      set(value) {
        this.updateField('legalType', value)
      },
    },
    urgent: {
      get() {
        return this.modelValue.urgent
      },
      set(value) {
        this.updateField('urgent', value)
      },
    },
    secret: {
      get() {
        return this.modelValue.secret
      },
      set(value) {
        this.updateField('secret', value)
      },
    },
    responsible: {
      get() {
        return this.modelValue.responsible
      },
      set(value) {
        this.updateField('responsible', value)
      },
    },
  },
  methods: {
    updateField(key, value) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        [key]: value,
      })
    },

    onKeyFrom(value) {
      this.$emit('keyup-from', value)
    },
    onKeyResponsible(value) {
      const updated = {
        ...this.modelValue,
        optionSelect: {
          ...this.modelValue.optionSelect,
          responsibles: [],
        },
      }
      this.$emit('update:modelValue', updated)

      this.axios
        .get('/user/lov', { params: value ? { keyword: value } : {} })
        .then((response) => {
          const responsibles = response.data.data || []
          responsibles.forEach((row) => {
            row.value = row.id
          })
          const updatedWithResponsibles = {
            ...this.modelValue,
            optionSelect: {
              ...this.modelValue.optionSelect,
              responsibles,
            },
          }
          this.$emit('update:modelValue', updatedWithResponsibles)
        })
        .catch((error) => {
          console.error('Failed to load responsible users', error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.advance-search-detail {
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 20px;
  border-bottom: 1px solid #e5e7eb;

  .input-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  .cols-span-2 {
    grid-column: span 2;
  }

  .group-input {
    width: 100%;

    .display-flex {
      width: 100%;
      gap: 20px;
    }

    .name {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }

  .between {
    display: flex;
    align-items: center;
    width: 100%;
    column-gap: 20px;
    row-gap: 10px;
    justify-content: space-between;
  }

  .to {
    font-size: 16px;
    font-weight: 500;
    text-align: left;
    color: #3e586d;
  }

  .component-date {
    width: 100%;
  }

  .input-keyword {
    width: 100%;
    height: 35px;
    border: 1px solid #c1cfe3;
    border-radius: 5px;
    padding: 8px 15px;
    color: #333;
    font-size: 12px;

    &:focus {
      outline: none;
      box-shadow: 0px 0px;
    }

    &::placeholder {
      font-size: 12px;
      color: #1a456b;
      opacity: 0.7;
      font-weight: 500;
    }
  }

  .group-button-advance {
    display: flex;
    gap: 10px;
  }
}

@media screen and (max-width: 768px) {
  .advance-search-detail {
    padding: 15px;

    .input-container {
      gap: 8px;
    }
  }

  .between {
    flex-wrap: wrap;
    justify-content: start !important;
    gap: 5px !important;
  }

  .component-date {
    max-width: 250px;
    min-width: 150px;
  }

  .group-input:has(.display-flex) {
    grid-column: span 2;
  }
}
</style>
